import { RowClassParams } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';

import { AgGridTable } from 'core/components';
import { TableLayoutType } from 'core/enums';
import { AgGridClientTableProvider } from 'core/states';
import { IProjectDetails } from 'projects/types';
import { isExternalProgram, isExternalProjectAccountActive } from 'projects/utils';

import { columnDef } from './columns';
import { getExternalCustomerRows, IExternalCustomerRow } from './utils';

interface IProps {
  project: IProjectDetails;
}

export const ExternalCustomerList = ({ project }: IProps) => {
  const isProgram = !!project?.externalProject && isExternalProgram(project.externalProject);

  const columnDefs = useMemo(() => columnDef(isProgram), [isProgram]);

  const defaultColDef = useMemo(() => ({ autoHeight: true }), []);

  const externalCustomerRows = useMemo(
    () => getExternalCustomerRows(project?.externalProject),
    [project]
  );

  const getRowClass = useCallback(
    ({ data }: RowClassParams<IExternalCustomerRow>) =>
      data && !isExternalProjectAccountActive(data) ? 'disabledRow' : undefined,
    []
  );

  return (
    <AgGridClientTableProvider
      tableId="externalCustomerListTable"
      entityType="ExternalCustomer"
      columnDefs={columnDefs}
      defaultColDef={defaultColDef}
      data={externalCustomerRows}
      isDataLoading={false}
      loadingPercentage={100}
      layoutType={TableLayoutType.PROJECT_EXTERNAL_CUSTOMER}
      hasRowSelection={false}
      hasLayoutActions
      getRowClass={getRowClass}
    >
      <AgGridTable />
    </AgGridClientTableProvider>
  );
};
